import { useParams } from "react-router-dom";

export const useExcludedIPCreatePageParams = () => {
  const { siteSlug = "" } = useParams();

  return { siteSlug };
};
